module.exports = __webpack_public_path__ + "static/media/remove.039a106b.svg";